/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetUserSessionIssuerCimdClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUserSessionIssuerCimdClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUserSessionIssuerCimdClientSecurity = {
  option1?: GetUserSessionIssuerCimdClientSecurityOption1 | undefined;
  option2?: GetUserSessionIssuerCimdClientSecurityOption2 | undefined;
};

export type GetUserSessionIssuerCimdClientRequest = {
  /**
   * The user_session_issuer_cimd_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetUserSessionIssuerCimdClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUserSessionIssuerCimdClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerCimdClientSecurityOption1$Outbound,
    GetUserSessionIssuerCimdClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUserSessionIssuerCimdClientSecurityOption1ToJSON(
  getUserSessionIssuerCimdClientSecurityOption1:
    GetUserSessionIssuerCimdClientSecurityOption1,
): string {
  return JSON.stringify(
    GetUserSessionIssuerCimdClientSecurityOption1$outboundSchema.parse(
      getUserSessionIssuerCimdClientSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerCimdClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUserSessionIssuerCimdClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerCimdClientSecurityOption2$Outbound,
    GetUserSessionIssuerCimdClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUserSessionIssuerCimdClientSecurityOption2ToJSON(
  getUserSessionIssuerCimdClientSecurityOption2:
    GetUserSessionIssuerCimdClientSecurityOption2,
): string {
  return JSON.stringify(
    GetUserSessionIssuerCimdClientSecurityOption2$outboundSchema.parse(
      getUserSessionIssuerCimdClientSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerCimdClientSecurity$Outbound = {
  Option1?: GetUserSessionIssuerCimdClientSecurityOption1$Outbound | undefined;
  Option2?: GetUserSessionIssuerCimdClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerCimdClientSecurity$Outbound,
    GetUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetUserSessionIssuerCimdClientSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetUserSessionIssuerCimdClientSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getUserSessionIssuerCimdClientSecurityToJSON(
  getUserSessionIssuerCimdClientSecurity:
    GetUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    GetUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      getUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerCimdClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerCimdClientRequest$Outbound,
    GetUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function getUserSessionIssuerCimdClientRequestToJSON(
  getUserSessionIssuerCimdClientRequest: GetUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    GetUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      getUserSessionIssuerCimdClientRequest,
    ),
  );
}
